import { Directive } from '@angular/core';
import { IfCheckoutProcessDirective } from './if-checkout-process.directive';
@Directive({
    standalone: true,
    selector: '[ifNotCheckoutProcess]'
})
export class IfNotCheckoutProcessDirective extends IfCheckoutProcessDirective {
    protected override check(): boolean {
        return !super.check();
    }
}
